"use client"
import React, { useEffect, useState, memo } from 'react';
import { useMediaQuery, useTheme } from '@mui/system';
import { useLanguage } from '../contexts/LanguageContext';


// --- Type Definitions ---
type IconType = 'accounting' | 'structure' | 'tech' | 'marketing' | 'auditing' | 'hr';

type GlowColor = 'cyan' | 'purple' | 'white';

interface SkillIconProps {
    type: IconType;
}



interface SkillConfig {
    id: string;
    orbitRadius: number;
    size: number;
    speed: number;
    iconType: IconType;
    phaseShift: number;
    glowColor: GlowColor;
    label: string;
    backgroundColor: string;
}

interface OrbitingSkillProps {
    config: SkillConfig;
    angle: number;
    backgroundColor: string;
}

interface GlowingOrbitPathProps {
    radius: number;
    glowColor?: GlowColor;
    animationDelay?: number;
}

// --- Improved SVG Icon Components ---



const iconComponents: Record<IconType, { component: () => React.JSX.Element; color: string }> = {


    accounting: {


        component: () => (


            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" className="w-full h-full">


                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>


                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>


                <g id="SVGRepo_iconCarrier">


                    <defs>


                        <style>{`.cls-1{fill:#fff;}.cls-2{fill:#000;}`}</style>


                    </defs>


                    <g data-name="4. Calculator" id="_4._Calculator">


                        <path className="cls-1" d="M27,22a1,1,0,0,0-1,1v6a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V9A1,1,0,0,0,4,9V29a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V23A1,1,0,0,0,27,22Z"></path>


                        <path className="cls-1" d="M25,0H7A3,3,0,0,0,4,3V5A1,1,0,0,0,6,5V3A1,1,0,0,1,7,2H25a1,1,0,0,1,1,1V19a1,1,0,0,0,2,0V3A3,3,0,0,0,25,0Z"></path>


                        <path className="cls-1" d="M24,5a1,1,0,0,0-1-1H9A1,1,0,0,0,8,5v6a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1Zm-2,5H10V6H22Z"></path>


                        <path className="cls-1" d="M9,16h2a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"></path>


                        <path className="cls-1" d="M17,14H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>


                        <path className="cls-1" d="M23,14H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>


                        <path className="cls-1" d="M9,20h2a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"></path>


                        <path className="cls-1" d="M17,18H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>


                        <path className="cls-1" d="M23,18H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>


                        <path className="cls-1" d="M9,24h2a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"></path>


                        <path className="cls-1" d="M17,22H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>


                        <path className="cls-1" d="M9,28h2a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"></path>


                        <path className="cls-1" d="M17,26H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>


                        <rect className="cls-2" height="6" rx="1" width="4" x="20" y="22"></rect>


                    </g>


                </g>


            </svg>


        ),


        color: '#E34F26'


    },


    structure: {


        component: () => (


            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000" className="w-full h-full">


                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>


                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>


                <g id="SVGRepo_iconCarrier">


                    <defs>


                        <style>{`.cls-1{fill:#ffffff;}.cls-2{fill:#fff;}`}</style>


                    </defs>


                    <g data-name="37. Teamwork" id="_37._Teamwork">


                        <path className="cls-1" d="M25,26a5,5,0,1,1,5-5A5.006,5.006,0,0,1,25,26Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,25,18Z"></path>


                        <path className="cls-1" d="M22,32H20a1,1,0,0,1-.98-.8l-1-5a1,1,0,0,1,.533-1.091l3.6-1.8a1,1,0,1,1,.894,1.789L20.13,26.553,20.82,30H22a1,1,0,0,1,0,2Z"></path>


                        <path className="cls-1" d="M30,32H26a1,1,0,0,1,0-2h3.18l.69-3.447L26.953,25.1a1,1,0,1,1,.894-1.789l3.6,1.8A1,1,0,0,1,31.98,26.2l-1,5A1,1,0,0,1,30,32Z"></path>


                        <path className="cls-1" d="M7,26a5,5,0,1,1,5-5A5.006,5.006,0,0,1,7,26Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,7,18Z"></path>


                        <path className="cls-1" d="M4,32H2a1,1,0,0,1-.98-.8l-1-5a1,1,0,0,1,.533-1.091l3.6-1.8A1,1,0,1,1,5.047,25.1L2.13,26.553,2.82,30H4a1,1,0,0,1,0,2Z"></path>


                        <path className="cls-1" d="M12,32H8a1,1,0,0,1,0-2h3.18l.69-3.447L8.953,25.1a1,1,0,1,1,.894-1.789l3.6,1.8A1,1,0,0,1,13.98,26.2l-1,5A1,1,0,0,1,12,32Z"></path>


                        <path className="cls-2" d="M16.706,16H15.294A2.3,2.3,0,0,1,13,13.706a.294.294,0,0,0-.441-.255,2.294,2.294,0,0,1-3.135-.84l-.7-1.222a2.3,2.3,0,0,1,.84-3.134.295.295,0,0,0,0-.51,2.3,2.3,0,0,1-.84-3.134l.705-1.222a2.294,2.294,0,0,1,3.135-.84A.294.294,0,0,0,13,2.294,2.3,2.3,0,0,1,15.294,0h1.412A2.3,2.3,0,0,1,19,2.294a.284.284,0,0,0,.147.255.291.291,0,0,0,.294,0,2.294,2.294,0,0,1,3.135.84l.7,1.222a2.3,2.3,0,0,1-.84,3.134.295.295,0,0,0,0,.51,2.3,2.3,0,0,1,.84,3.134l-.7,1.222a2.294,2.294,0,0,1-3.135.84.288.288,0,0,0-.294,0,.284.284,0,0,0-.147.255A2.3,2.3,0,0,1,16.706,16Zm-4-4.592A2.3,2.3,0,0,1,15,13.706a.294.294,0,0,0,.294.294h1.412A.294.294,0,0,0,17,13.706a2.294,2.294,0,0,1,3.441-1.987.281.281,0,0,0,.224.029.285.285,0,0,0,.178-.137l.706-1.222a.293.293,0,0,0-.108-.4,2.295,2.295,0,0,1,0-3.974.293.293,0,0,0,.108-.4h0l-.706-1.222a.285.285,0,0,0-.178-.137.289.289,0,0,0-.224.029A2.294,2.294,0,0,1,17,2.294.294.294,0,0,0,16.706,2H15.294A.294.294,0,0,0,15,2.294a2.294,2.294,0,0,1-3.441,1.987.289.289,0,0,0-.224-.029.285.285,0,0,0-.178.137l-.706,1.222a.293.293,0,0,0,.108.4,2.295,2.295,0,0,1,0,3.974.293.293,0,0,0-.108.4l.706,1.222a.285.285,0,0,0,.178.137.28.28,0,0,0,.224-.029A2.292,2.292,0,0,1,12.706,11.408Z"></path>


                        <path className="cls-2" d="M16,10a2,2,0,1,1,2-2A2,2,0,0,1,16,10Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z"></path>


                    </g>


                </g>


            </svg>


        ),


        color: '#1572B6'


    },


    tech: {


        component: () => (


            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff" className="w-full h-full">


                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>


                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>


                <g id="SVGRepo_iconCarrier">


                    <defs>


                        <style>{`.cls-1{fill:#fffffffffff;}.cls-2{fill:#fffffffff;}`}</style>


                    </defs>


                    <g data-name="8. Monitor Screen" id="_8._Monitor_Screen">


                        <path className="cls-1" d="M31,18a1,1,0,0,0,1-1V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V23a3,3,0,0,0,3,3H8a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1V22H30v1a1,1,0,0,1-1,1H12a1,1,0,0,0-1,1v1.171A5.786,5.786,0,0,1,9.559,30H8a1,1,0,0,0,0,2H24a1,1,0,0,0,0-2H22.441A5.788,5.788,0,0,1,21,26.171V26h8a3,3,0,0,0,3-3V21a1,1,0,0,0-1-1H2V3A1,1,0,0,1,3,2H29a1,1,0,0,1,1,1V17A1,1,0,0,0,31,18ZM20,30H12a7.787,7.787,0,0,0,1-3.829V26h6v.171A7.787,7.787,0,0,0,20,30Z"></path>


                        <path className="cls-2" d="M19,18H5a1,1,0,0,1,0-2H19a1,1,0,0,1,0,2Z"></path>


                        <path className="cls-2" d="M27,14H5a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z"></path>


                        <path className="cls-2" d="M27,10H5A1,1,0,0,1,5,8H27a1,1,0,0,1,0,2Z"></path>


                        <path className="cls-2" d="M22,6H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z"></path>


                    </g>


                </g>


            </svg>


        ),


        color: '#F7DF1E'


    },


    marketing: {


        component: () => (


            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" stroke="#ffffff" className="w-full h-full">


                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>


                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>


                <g id="SVGRepo_iconCarrier">


                    <defs>


                        <style>{`.cls-1{fill:#fffffffffff;}.cls-2{fill:#fffffffff;}`}</style>


                    </defs>


                    <g data-name="28. Board" id="_28._Board">


                        <path className="cls-1" d="M17,26H3a3,3,0,0,1-3-3V5A3,3,0,0,1,3,2h9a1,1,0,0,1,0,2H3A1,1,0,0,0,2,5V23a1,1,0,0,0,1,1H17a1,1,0,0,1,0,2Z"></path>


                        <path className="cls-1" d="M29,26H21a1,1,0,0,1,0-2h8a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H16a1,1,0,0,1,0-2H29a3,3,0,0,1,3,3V23A3,3,0,0,1,29,26Z"></path>


                        <path className="cls-1" d="M8,32a1,1,0,0,1-.894-1.447l3-6a1,1,0,1,1,1.79.894l-3,6A1,1,0,0,1,8,32Z"></path>


                        <path className="cls-1" d="M24,32a1,1,0,0,1-.9-.553l-3-6a1,1,0,0,1,1.79-.894l3,6A1,1,0,0,1,24,32Z"></path>


                        <path className="cls-1" d="M16,4a1,1,0,0,1-1-1V1a1,1,0,0,1,2,0V3A1,1,0,0,1,16,4Z"></path>


                        <path className="cls-2" d="M5,19a1,1,0,0,1-.707-1.707l6-6A.982.982,0,0,1,11.045,11a1,1,0,0,1,.723.358l4.3,5.16,9.226-9.226a1,1,0,1,1,1.414,1.414l-10,10a.983.983,0,0,1-.752.292,1,1,0,0,1-.723-.358l-4.3-5.16L5.707,18.707A1,1,0,0,1,5,19Z"></path>


                        <path className="cls-2" d="M27,12a1,1,0,0,1-1-1V8H23a1,1,0,0,1,0-2h4a1,1,0,0,1,1,1v4A1,1,0,0,1,27,12Z"></path>


                    </g>


                </g>


            </svg>


        ),


        color: '#61DAFB'


    },


    auditing: {


        component: () => (


            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" stroke="#ffffff" className="w-full h-full">


                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>


                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>


                <g id="SVGRepo_iconCarrier">


                    <defs>


                        <style>{`.cls-1{fill:#ffffff;}.cls-2{fill:#fffffffffff;}`}</style>


                    </defs>


                    <g data-name="26. Clipboard" id="_26._Clipboard">


                        <path className="cls-1" d="M25,32H7a3,3,0,0,1-3-3V7A3,3,0,0,1,7,4H8A1,1,0,0,1,8,6H7A1,1,0,0,0,6,7V29a1,1,0,0,0,1,1H25a1,1,0,0,0,1-1V16a1,1,0,0,1,2,0V29A3,3,0,0,1,25,32Z"></path>


                        <path className="cls-1" d="M27,13a1,1,0,0,1-1-1V7a1,1,0,0,0-1-1H20a1,1,0,0,1,0-2h5a3,3,0,0,1,3,3v5A1,1,0,0,1,27,13Z"></path>


                        <path className="cls-1" d="M19,8H13a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V6A2,2,0,0,1,19,8ZM13,4V6h6V4Z"></path>


                        <path className="cls-1" d="M16,4a1,1,0,0,1-1-1V1a1,1,0,0,1,2,0V3A1,1,0,0,1,16,4Z"></path>


                        <path className="cls-1" d="M13,17H9a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,13,17Zm-3-2h2V13H10Z"></path>
                        <path className="cls-1" d="M13,26H9a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,13,26Zm-3-2h2V22H10Z"></path>
                        <path className="cls-2" d="M23,15H17a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"></path>
                        <path className="cls-2" d="M23,24H17a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"></path>
                    </g>
                </g>
            </svg>
        ),
        color: '#339933'
    },
    hr: {
        component: () => (
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" stroke="#ffffff" className="w-full h-full">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <defs>
                        <style>{`.cls-1{fill:#fffffffffff;}.cls-2{fill:#ffffff;}`}</style>
                    </defs>
                    <g data-name="21. Switch" id="_21._Switch">
                        <path className="cls-1" d="M7,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,7,10ZM7,2a3,3,0,1,0,3,3A3,3,0,0,0,7,2Z"></path>
                        <path className="cls-1" d="M4,16H2a1,1,0,0,1-.98-.8l-1-5A1,1,0,0,1,.553,9.105l3.6-1.8A1,1,0,1,1,5.047,9.1L2.13,10.553,2.82,14H4a1,1,0,0,1,0,2Z"></path>
                        <path className="cls-1" d="M12,16H8a1,1,0,0,1,0-2h3.18l.69-3.447L8.953,9.1a1,1,0,1,1,.894-1.789l3.6,1.8A1,1,0,0,1,13.98,10.2l-1,5A1,1,0,0,1,12,16Z"></path>
                        <path className="cls-1" d="M25,26a5,5,0,1,1,5-5A5.006,5.006,0,0,1,25,26Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,25,18Z"></path>
                        <path className="cls-1" d="M22,32H20a1,1,0,0,1-.98-.8l-1-5a1,1,0,0,1,.533-1.091l3.6-1.8a1,1,0,1,1,.894,1.789L20.13,26.553,20.82,30H22a1,1,0,0,1,0,2Z"></path>
                        <path className="cls-1" d="M30,32H26a1,1,0,0,1,0-2h3.18l.69-3.447L26.953,25.1a1,1,0,1,1,.894-1.789l3.6,1.8A1,1,0,0,1,31.98,26.2l-1,5A1,1,0,0,1,30,32Z"></path>
                        <path className="cls-2" d="M25,14a1,1,0,0,1-1-1V11a5.006,5.006,0,0,0-5-5H17a1,1,0,0,1,0-2h2a7.008,7.008,0,0,1,7,7v2A1,1,0,0,1,25,14Z"></path>
                        <path className="cls-2" d="M17,8a1,1,0,0,1-.707-.293l-2-2a1,1,0,0,1,0-1.414l2-2a1,1,0,1,1,1.414,1.414L16.414,5l1.293,1.293A1,1,0,0,1,17,8Z"></path>
                        <path className="cls-2" d="M13,28H11a5.006,5.006,0,0,1-5-5V19a1,1,0,0,1,2,0v4a3,3,0,0,0,3,3h2a1,1,0,0,1,0,2Z"></path>
                        <path className="cls-2" d="M13,30a1,1,0,0,1-.707-1.707L13.586,27l-1.293-1.293a1,1,0,0,1,1.414-1.414l2,2a1,1,0,0,1,0,1.414l-2,2A1,1,0,0,1,13,30Z"></path>
                    </g>
                </g>
            </svg>
        ),
        color: '#06B6D4'
    }
};

// --- Memoized Skill Icon Component ---
const SkillIcon = memo(({ type }: SkillIconProps) => {
    const IconComponent = iconComponents[type]?.component;
    return IconComponent ? <IconComponent /> : null;
});

SkillIcon.displayName = 'SkillIcon';

// --- Configuration for the Orbiting Skills ---
const getSkillsConfig = (t: (key: string) => string, language: string): SkillConfig[] => [

    // Inner Orbit
    {
        id: 'accounting',
        orbitRadius: typeof window !== "undefined" && window.innerWidth < 768 ? 60 : 200,
        size: 35,
        speed: 1,
        iconType: 'accounting', 
        phaseShift: 0,
        glowColor: 'cyan',
        label: language === 'ar' ? t('skills.accounting.title') : t('skills.accounting.title'),
        backgroundColor: 'gray'
    },
    {
        id: 'structure',
        orbitRadius: typeof window !== "undefined" && window.innerWidth < 768 ? 60 : 200,
        size: 30,
        speed: 1,
        iconType: 'structure',
        phaseShift: (2 * Math.PI) / 3,
        glowColor: 'cyan',
        label: language === 'ar' ? t('skills.structure.title') : t('skills.structure.title'),
        backgroundColor: 'gray'
    },
    {
        id: 'tech',
        orbitRadius: typeof window !== "undefined" && window.innerWidth < 768 ? 60 : 200,
        size: 35,
        speed: 1,
        iconType: 'tech',
        phaseShift: (4 * Math.PI) / 3,
        glowColor: 'cyan',
        label: language === 'ar' ? t('skills.tech.title') : t('skills.tech.title'),
        backgroundColor: 'gray'
    },
    // Outer Orbit
    {
        id: 'marketing',
        orbitRadius: typeof window !== "undefined" && window.innerWidth < 768 ? 100 : 280,
        size: 35,
        speed: -0.6,
        iconType: 'marketing',
        phaseShift: 0,
        glowColor: 'purple',
        label: language === 'ar' ? t('skills.marketing.title') : t('skills.marketing.title'),
        backgroundColor: 'gray'
    },
    {
        id: 'auditing',
        orbitRadius: typeof window !== "undefined" && window.innerWidth < 768 ? 100 : 280,
        size: 35,
        speed: -0.6,
        iconType: 'auditing',
        phaseShift: (2 * Math.PI) / 3,
        glowColor: 'purple',
        label: language === 'ar' ? t('skills.auditing.title') : t('skills.auditing.title'),
        backgroundColor: 'gray'
    },
    {
        id: 'hr',
        orbitRadius: typeof window !== "undefined" && window.innerWidth < 768 ? 100 : 280,
        size: 35,
        speed: -0.6,
        iconType: 'hr',
        phaseShift: (4 * Math.PI) / 3,
        glowColor: 'purple',
        label: language === 'ar' ? t('skills.hr.title') : t('skills.hr.title'),
        backgroundColor: 'gray'
    },
];

// --- Memoized Orbiting Skill Component ---
const OrbitingSkill = memo(({ config, angle }: OrbitingSkillProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const { orbitRadius, size, iconType, label } = config;

    const x = Math.cos(angle) * orbitRadius;
    const y = Math.sin(angle) * orbitRadius;

    return (
        <div
            className={`absolute transition-all duration-300 ease-out z-1000`}
            style={{
                top: '50%',
                left: '50%',
                width: `${size}px`,
                height: `${size}px`,
                // Center first, then offset using pixel translation for Safari reliability
                transform: `translate(-50%, -50%) translate3d(${x}px, ${y}px, 0)`,
                zIndex: isHovered ? 20 : 10,
                willChange: 'transform',
                backfaceVisibility: 'hidden',
                perspective: '1000px',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div
                className={`
          relative w-full h-full p-2 bg-gray-800/90 backdrop-blur-sm
          rounded-full flex items-center justify-center
          transition-all duration-300 cursor-pointer
          ${isHovered ? 'scale-125 shadow-2xl' : 'shadow-lg hover:shadow-xl'}
        `}
                style={{
                    transform: isHovered ? 'scale(1.5)' : 'scale(1)',
                    transformOrigin: 'center',
                    willChange: 'transform',
                    
                    boxShadow: isHovered
                        ? `0 0 30px ${iconComponents[iconType]?.color}40, 0 0 60px ${iconComponents[iconType]?.color}20`
                        : undefined
                }}
            >
                <SkillIcon type={iconType} />
                {isHovered && (
                    <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-900/95 backdrop-blur-sm rounded text-xs text-white whitespace-nowrap pointer-events-none">
                        {label}
                    </div>
                )}
            </div>
        </div>
    );
});
OrbitingSkill.displayName = 'OrbitingSkill';

// --- Optimized Orbit Path Component ---
const GlowingOrbitPath = memo(({ radius, glowColor = 'cyan', animationDelay = 0 }: GlowingOrbitPathProps) => {
    const glowColors = {
        cyan: {
            primary: 'rgba(6, 182, 212, 0.4)',
            secondary: 'rgba(6, 182, 212, 0.2)',
            border: 'rgba(6, 182, 212, 0.3)'
        },
        purple: {
            primary: 'rgba(147, 51, 234, 0.4)',
            secondary: 'rgba(147, 51, 234, 0.2)',
            border: 'rgba(147, 51, 234, 0.3)'
        },
        white: {
            primary: 'rgba(255, 255, 255, 0.4)',
            secondary: 'rgba(255, 255, 255, 0.2)',
            border: 'rgba(255, 255, 255, 0.3)'
        }
    };

    const colors = glowColors[glowColor] || glowColors.white;

    return (
        <div
            className="absolute rounded-full pointer-events-none"
            style={{
                top: '50%',
                left: '50%',
                width: `${radius * 2}px`,
                height: `${radius * 2}px`,
                transform: 'translate(-50%, -50%) translateZ(0)',
                animationDelay: `${animationDelay}s`,
                willChange: 'transform',
                backfaceVisibility: 'hidden',
            }}
        >
            {/* Glowing background */}
            <div
                className="absolute inset-0 rounded-full animate-pulse"
                style={{
                    background: `radial-gradient(circle, transparent 30%, ${colors.secondary} 70%, ${colors.primary} 100%)`,
                    boxShadow: `0 0 60px ${colors.primary}, inset 0 0 60px ${colors.secondary}`,
                    animation: 'pulse 4s ease-in-out infinite',
                    animationDelay: `${animationDelay}s`,
                    willChange: 'transform',
                    backfaceVisibility: 'hidden',
                    transform: 'translateZ(0)',
                }}
            />

            {/* Static ring for depth */}
            <div
                className="absolute inset-0 rounded-full"
                style={{
                    border: `1px solid ${colors.border}`,
                    boxShadow: `inset 0 0 20px ${colors.secondary}`,
                    willChange: 'transform',
                    backfaceVisibility: 'hidden',
                    transform: 'translateZ(0)',
                }}
            />
        </div>
    );
});
GlowingOrbitPath.displayName = 'GlowingOrbitPath';

// --- Main App Component ---
export default function OrbitingSkills() {
    const [time, setTime] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { t, language } = useLanguage();

    useEffect(() => {
        if (isPaused) return;

        let animationFrameId: number;
        let lastTime = performance.now();

        const animate = (currentTime: number) => {
            const deltaTime = (currentTime - lastTime) / 1000;
            lastTime = currentTime;

            setTime(prevTime => prevTime + deltaTime);
            animationFrameId = requestAnimationFrame(animate);
        };

        animationFrameId = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(animationFrameId);
    }, [isPaused]);

    const orbitConfigs: Array<{ radius: number; glowColor: GlowColor; delay: number }> = [
        { radius: isMobile ? 60 : 200, glowColor: 'cyan', delay: 0 },
        { radius: isMobile ? 100 : 280, glowColor: 'white', delay: 1.5 }
    ];

    return (
        <main className="w-full flex items-center justify-center ">
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-10">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: `radial-gradient(circle at 25% 25%, #374151 0%, transparent 50%),
                             radial-gradient(circle at 75% 75%, #4B5563 0%, transparent 50%)`,
                    }}
                />
            </div>

            <div
                className="relative w-[300px] h-[300px] md:w-[450px] md:h-[650px] flex items-center justify-center mx-auto"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                style={{
                    willChange: 'transform',
                    backfaceVisibility: 'hidden',
                    perspective: '1000px',
                    transform: 'translateZ(0)',
                }}
            >

                {/* Central "Code" Icon with enhanced glow */}
                <div
                    className="md:w-[10rem] md:h-[10rem] w-[5rem] h-[5rem] bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex items-center justify-center z-10 relative shadow-2xl"
                    style={{
                        willChange: 'transform',
                        backfaceVisibility: 'hidden',
                        transform: 'translateZ(0)',
                    }}
                >
                    <div
                        className="absolute inset-0 rounded-full bg-cyan-500/30 blur-xl animate-pulse"
                        style={{
                            willChange: 'transform',
                            backfaceVisibility: 'hidden',
                        }}
                    ></div>
                    <div
                        className="absolute inset-0 rounded-full bg-purple-500/20 blur-2xl animate-pulse"
                        style={{
                            animationDelay: '1s',
                            willChange: 'transform',
                            backfaceVisibility: 'hidden',
                        }}
                    ></div>
                    <div
                        className="relative z-10 flex items-center justify-center"
                        style={{
                            willChange: 'transform',
                            backfaceVisibility: 'hidden',
                        }}
                    >
                        <img
                            src='/images/logo.png'
                            alt='MOKTAMEL'
                            className='w-[80%] h-[80%]'
                            style={{
                                willChange: 'transform',
                                backfaceVisibility: 'hidden',
                            }}
                        />
                    </div>
                </div>

                {/* Render glowing orbit paths */}
                {orbitConfigs.map((config) => (
                    <GlowingOrbitPath
                        key={`path-${config.radius}`}
                        radius={config.radius}
                        glowColor={config.glowColor}
                        animationDelay={config.delay}
                    />
                ))}

                {/* Render orbiting skill icons */}
                {getSkillsConfig(t, language).map((config) => {
                    const angle = time * config.speed + (config.phaseShift || 0);
                    return (
                        <OrbitingSkill
                            key={config.id}
                            config={config}
                            angle={angle}
                            backgroundColor={config.backgroundColor}
                        />
                    );
                })}
            </div>
        </main>
    );
}